const isNegativeNumber = (value) => Number.isFinite(value) && value < 0;

export default isNegativeNumber;
